var poll_header_default = {
  "title": "Vvazy",
  "image": "AlkEN",
  "webview": "AX-D6"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
